import { createBillingOrder } from '@/services';
import { CreateBillingOrderRequest } from '@/services/billing/types/create-billing.type';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useCreateBillingOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateBillingOrderRequest) => await createBillingOrder(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['orderList'] });
    },
  });
};
